import { useState, useRef, useEffect } from "react";
import { getPaymentTypeLabel, getPaymentTypeDescription } from "../utils/paymentTypes";

export default function PaymentTooltip({ category }) {
  const [visible, setVisible] = useState(false);
  const tooltipRef = useRef(null);
  const shortName = getPaymentTypeLabel(category);
  const description = getPaymentTypeDescription(category);

  // Close tooltip when clicking outside on mobile
  useEffect(() => {
    if (!visible) return;
    function handleClickOutside(e) {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [visible]);

  return (
    <span ref={tooltipRef} className="relative inline-flex items-center ml-1">
      <button
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setVisible(!visible);
        }}
        className="w-3.5 h-3.5 rounded-full bg-white/10 hover:bg-white/20 text-white/40 hover:text-white/70 text-xs flex items-center justify-center transition-colors leading-none"
        style={{ fontSize: "9px" }}
        aria-label={`What is ${shortName}?`}
      >
        ?
      </button>
      {visible && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 bg-navy-900 border border-white/10 rounded-xl p-3 text-xs text-white/70 leading-relaxed z-50 shadow-xl">
          <p className="text-white/90 font-medium mb-1">{shortName}</p>
          <p>{description}</p>
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-navy-900 border-r border-b border-white/10 rotate-45 -mt-1" />
        </div>
      )}
    </span>
  );
}